import {
  Component,
  OnInit,
  forwardRef,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  Injector,
  SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ConfirmationService, DialogService, DynamicDialogRef, FileUpload, MessageService } from 'primeng/primeng';
import { ConfigurationService } from '../../../services/configuration.service';
import { environment } from '../../../../../environments/environment';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { VsFileUploadService } from '../services/file-upload.service';
import { SecondPageEditBase } from '../../../classes/base/second-page-edit-base';
import { FilesService } from '../services/files.service';
import { FileType } from '../../../../dapfood/common/constant';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';

@Component({
  selector: 'app-hq-file-upload-comment',
  templateUrl: './hq-file-upload-comment.component.html',
  styleUrls: ['./hq-file-upload-comment.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HqFileUploadCommentComponent),
      multi: true
    }
  ]
})
export class HqFileUploadCommentComponent extends SecondPageEditBase implements OnInit, ControlValueAccessor {
  disabled = false;
  apiUrl = '';
  uploading = false;
  maxFileSize = 0;
  listUploaded: any[];
  progressValue = 0;
  ref: DynamicDialogRef;

  @ViewChild(FileUpload) fileControl: FileUpload;

  @Input() chooseLabel = 'Chọn file';
  @Input() multiple = false;
  @Input() styleButton = false;
  @Input() defaultImage = false;
  @Input() showIconOnly = false;
  @Input() icon = 'fa-light fa-upload';
  @Input() viewOnly = false;
  @Input() fileType = '';    // '' , image/* , video/* , 
  @Input() filePasteUpload: any;
  @Input() iconUploadMessage: boolean = false;
  @Output() onUploaded: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(FileViewerComponent) _FileViewerComponent: FileViewerComponent;

  constructor(
    protected _injector: Injector,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fileUploadService: VsFileUploadService,
    private _configurationService: ConfigurationService,
    public dialogService: DialogService,
    private _fileService: FilesService,
  ) {
    super(null, _injector);
    this.apiUrl = `${environment.apiDomain.fileEndpoint}/Files/upload`;  // _moduleConfigService.getConfig().ApiFileUpload;
    this.maxFileSize = this._configurationService.maxFileSize;
  }

  ngOnInit() {
    // this.onUploadEventPaste(this.filePasteUpload)
    // console.log(this.filePasteUpload);
  }
  ngAffterViewInit() {
    console.log(this.filePasteUpload);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filePasteUpload && changes.filePasteUpload.currentValue) {
      this.onUploadEventPaste(this.filePasteUpload);
    }
  }

  onChangeControl = (obj: any) => { };
  onTouched = () => { };

  writeValue(obj: any): void {
    this.listUploaded = [];
    if (obj) {
      this.listUploaded = obj.split(",");

      this._fileUploadService.GetsByIds(obj).then(rs => {
        if (rs.status) {
          this.listUploaded = rs.data;
        }
      }).catch(err => {
        console.log('Có lỗi xảy ra, vui lòng thử lại ' + err);
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeControl = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onUploadEvent(event: any) {
    try {
      const files = event.files;
      if (files.length > 0) {
        if (event.originalEvent.body && event.originalEvent.body.status) {

          //Nếu là single thì clear list đi để lưu ảnh mới, nếu là multi thì push thêm ảnh
          if (this.multiple == false)
            this.listUploaded = [];

          event.originalEvent.body.data.forEach(element => {

            this.listUploaded.push(element);// list object file  

          });

          let files = this.listUploaded.map(x => x.id).join(",");
          this.onChangeControl(files);
          this.onUploaded.next(files);

          this.progressValue = 100;
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.uploading = false;
  }

  onUploadEventPaste(filePasteUpload: any) {
    try {
      if (filePasteUpload) {
        this.convertFileToBinary(filePasteUpload);
      }
    } catch (e) {
      console.error(e);
    }
    this.uploading = false;
  }

  convertFileToBinary(file: File) {
    let reader = new FileReader();
    reader.onload = (event) => {
      let binaryData: Blob;

      // kiểm tra dữ liệu đọc có fải là chuỗi ko để khởi tạo 1 Blob
      if (typeof reader.result === 'string') {
        binaryData = new Blob([reader.result], { type: 'application/octet-stream' });
      } else {
        binaryData = new Blob([reader.result], { type: 'application/octet-stream' });
      }
      // Tạo một đối tượng FormData để chứa dữ liệu nhị phân
      let formData = new FormData();
      formData.append('files', binaryData, file.name);
      this.progressValue = 1;
      this._fileService.upload(formData).then(res => {
        if (res.status) {
          res.data.forEach(item => {
            this.listUploaded.push(item);
          });
          let files = this.listUploaded.map(x => x.id).join(",");
          this.onChangeControl(files);
          this.onUploaded.next(files);

          this.progressValue = 100;
        }
      });
    };
    reader.readAsArrayBuffer(file);
  }

  onProgress(event) {
    // if (event.originalEvent.loaded !== 0) {
    //   this.progressValue = (event.originalEvent.loaded / event.originalEvent.total) * 100;
    // }
  }

  deleteFile(id) {
    this.confirmationService.confirm({
      message: 'Bạn có chắc chắn muốn xóa file này không ?',
      header: 'Xác nhận xóa',
      icon: 'pi pi-trash',
      accept: () => {
        const fileToRemove = this.listUploaded.findIndex(x => x.id === id);
        this.listUploaded.splice(fileToRemove, 1);
        let files = this.listUploaded.map(x => x.id).join(",");
        this.onChangeControl(files);
        this.onUploaded.next(files);

        this.writeValue(files);
      }
    });
  }

  onBeforeSend(ev) {
    console.log(ev);
  }

  onError(ev) {
    console.log(ev);
    this.uploading = false;
  }

  onSelect(ev) {
    console.log(ev);
    // this.messageService.add({ severity: 'error', summary: 'Lỗi upload file', detail: 'Vui lòng kiểm tra lại định dạng file', life: 10000 });
  }

  selectFileUpload() {
    this.fileControl.basicFileInput.nativeElement.click();
  }

  onBeforeUpload() {
    this.progressValue = 1;
    this.uploading = true;
  }
  viewFile(item) {
    // Nếu file là hình ảnh hoặc video thì dùng FileViewer, Nếu là tài liệu thì dùng VsFileViewer
    if (item.type == FileType.Image || item.type == FileType.Video) {
      this.ref = this.dialogService.open(FileViewerComponent, {
        data: {
          file: this.listUploaded.find(s => s.id == item.id),
          listFile: this.multiple ? this.listUploaded : null
        },
        showHeader: false,
        width: '100%',
        height: 'calc(100vh)',
        styleClass: "vs-modal",
        contentStyle: { 'overflow': 'auto', 'position': 'relative' },
        baseZIndex: 1100,
        closeOnEscape: true,
      });
    }
    else {
      this.ref = this.dialogService.open(DocumentViewerComponent, {
        data: item,
        showHeader: true,
        header: item.fileName,
        width: '100%',
        height: 'calc(100vh - 0px)',
        styleClass: "vs-modal vs-file-viewer",
        contentStyle: { 'overflow': 'auto' }, //'max-height': 'calc(100vh - 180px);', 
        baseZIndex: 1100,
        closeOnEscape: true
      });

    }
  }

  downloadFileAll() {
    this.listUploaded.forEach(element => {
      this.downloadFile(element);
    });
  }

}
